import { Switch, Route, useLocation } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { MaintenanceModeProvider, useMaintenanceMode } from "@/contexts/maintenance-mode-context";
import Home from "@/pages/home";
import AdminLogin from "@/pages/admin-login";
import Admin from "@/pages/admin";
import KnowYourOfficials from "@/pages/know-your-officials";
import Gallery from "@/pages/gallery";
import MustKnowLaws from "@/pages/must-know-laws";
import StudentSection from "@/pages/student-section";
import JobsExams from "@/pages/jobs-exams";
import SchemesSewa from "@/pages/schemes-sewa";
import StudentResources from "@/pages/student-resources";
import Events from "@/pages/events";
import Community from "@/pages/community";
import Awareness from "@/pages/awareness";
import ComingSoon from "@/pages/coming-soon";
import NotFound from "@/pages/not-found";

function Router() {
  const { isMaintenanceMode, loading } = useMaintenanceMode()
  const [location] = useLocation()

  // Allow admin routes even during maintenance
  const isAdminRoute = location.startsWith('/admin') || location === '/admin-login'

  // Show loading state while checking maintenance mode
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // If maintenance mode is enabled and not on admin route, show coming soon page
  if (isMaintenanceMode && !isAdminRoute) {
    return <ComingSoon />
  }

  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/admin-login" component={AdminLogin} />
      <Route path="/admin" component={Admin} />
      <Route path="/know-your-officials" component={KnowYourOfficials} />
      <Route path="/gallery" component={Gallery} />
      <Route path="/must-know-laws" component={MustKnowLaws} />
      <Route path="/student-section" component={StudentSection} />
      <Route path="/jobs-exams" component={JobsExams} />
      <Route path="/schemes-sewa" component={SchemesSewa} />
      <Route path="/student-resources" component={StudentResources} />
      <Route path="/events" component={Events} />
      <Route path="/community" component={Community} />
      <Route path="/awareness" component={Awareness} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <MaintenanceModeProvider>
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </MaintenanceModeProvider>
    </QueryClientProvider>
  );
}

export default App;
